<template>
  <div class="jujuna-packs">
      <svg id="uceb" xmlns="http://www.w3.org/2000/svg" width="190.346" height="190.351" viewBox="0 0 190.346 190.351">
  <g id="Group_1743" data-name="Group 1743" transform="translate(-302.29 -379.216)">
    <path id="Path_3842" data-name="Path 3842" d="M454.635,514.171l29.572-.605-20.978-24.8,29.406-13.791-26.617-12.879L486.5,440.757l-32.37-2.709L465.173,407.5l-27.93,9.714-.608-29.564-24.8,20.973-13.791-29.409-12.882,26.617-21.337-20.472-2.706,32.364-30.545-11.041,9.711,27.93-29.558.6,20.97,24.8-29.406,13.8,26.617,12.879-20.478,21.332,32.364,2.706L329.75,541.283l27.933-9.717.605,29.564,24.8-20.973,13.794,29.409,12.882-26.62L431.1,563.425l2.709-32.367L464.349,542.1Z" transform="translate(0 0)" fill="#e9347a"/>
    <g id="Group_1742" data-name="Group 1742" transform="translate(340.001 446.601)">
      <path id="Path_3843" data-name="Path 3843" d="M344.979,442.085,337.629,426.8l4.633-2.232,5.076,10.559,10.832-21.77-11.923,1.226-.525-5.113,16.563-1.709,2.566,3.709L349.6,442.121Z" transform="translate(-277.652 -396.245)" fill="#f7d247"/>
      <g id="Group_1741" data-name="Group 1741" transform="translate(87.799 16.981)">
        <rect id="Rectangle_1662" data-name="Rectangle 1662" width="5.389" height="22.583" transform="matrix(0.031, -1, 1, 0.031, 5.693, 5.386)" fill="#f7d247"/>
        <rect id="Rectangle_1663" data-name="Rectangle 1663" width="16.81" height="5.391" transform="translate(8.411 17.323) rotate(-69.011)" fill="#f7d247"/>
        <path id="Path_3844" data-name="Path 3844" d="M355.254,435.788l-4.531-1.432-3.03-16.138,2.723-3.193,19.035.558,1.791,4.622Zm-1.639-15.278,1.476,7.909,7.837-7.632Z" transform="translate(-347.694 -400.405)" fill="#f7d247"/>
      </g>
      <path id="Path_3845" data-name="Path 3845" d="M315.932,436.952l.8-5.605,17.684,2.511,8-19.117-7.952,3.761-4.01-2.15-.58-3.98-4.923,6.439-4.5-3.44,9.006-11.777,5.051,1.315.993,6.836,11.154-5.277,3.821,3.652L338.8,438.05l-3.02,1.714Z" transform="translate(-315.932 -403.593)" fill="#f7d247"/>
      <path id="Path_3846" data-name="Path 3846" d="M328.6,439.139l-2.191-3.716,10.228-29.541,5.348,1.853-9.134,26.407,13.914,2.447,3.419-11.225-5.679-3.666.2-4.868,11.35-6.14,2.689,4.978-7.146,3.873,3.456,2.225,1.173,3.2-4.779,15.664-3.2,1.965Z" transform="translate(-297.44 -399.554)" fill="#f7d247"/>
    </g>
  </g>
</svg>
 
       <img src="@/assets/img/checkersyellow.png" class="yellow-shmaxi" alt="">
    <div class="container-landing">
     
       
      
  
      <div class="left-col">
        <div class="ttl-wrapper">
          <div class="bigger-ttl"><h2 class="f-55">{{ _.get(contentData, 'data.list[0].title') }}</h2></div>
          <div class="lesser-ttl">
            <span class="f-34 bold-italic">{{ _.get(contentData, 'data.list[0].price') }}₾</span>
          </div>
        </div>
        <div class="desc-box">
          <div class="col" v-for="(col, index) in this.getProduct[0].newIngredients.newArr" :key="index">
             <span class="f-16 light-italic w__change" v-if="$route.name === 'en'">{{col.front_title_en}}</span>
            <span class="f-16 light-italic w__change" v-if="$route.name === 'ge'">{{col.front_title_ge}}</span>
            <span class="f-16 bold w__change" v-if="$route.name === 'en'">{{col.descr_en}}</span>
            <span class="f-16 bold w__change" v-if="$route.name === 'ge'">{{col.descr_ge}}</span>
          </div>
          <!-- <div class="col">
                      <span class="f-16 light-italic w__change" v-if="$route.name === 'en'">{{getAlcohol.title_en}}</span>
            <span class="f-16 light-italic w__change" v-if="$route.name === 'ge'">{{getAlcohol.title_ge}}</span>
            <span class="f-16 bold w__change" v-if="$route.name === 'en'">{{getAlcohol.descr_en}}</span>
            <span class="f-16 bold w__change" v-if="$route.name === 'ge'">{{getAlcohol.descr_ge}}</span>
          </div>
          <div class="col">
                           <span class="f-16 light-italic w__change" v-if="$route.name === 'en'">{{getGas.title_en}}</span>
            <span class="f-16 light-italic w__change" v-if="$route.name === 'ge'">{{getGas.title_ge}}</span>
                    <span class="f-16 bold w__change" v-if="$route.name === 'en'">{{getGas.descr_en}}</span>
            <span class="f-16 bold w__change" v-if="$route.name === 'ge'">{{getGas.descr_ge}}</span>
          </div> -->
        </div>
           <div class="desc" v-html="_.get(contentData, 'data.list[0].description')"></div>
        <!-- <div class="locations-div">
            <span class="f-16 light-italic">{{$fn.tr('სად შევიძინო ჟუჟუნა?')}}</span>
            <OrderService />
        </div> -->
                <!-- <router-link :to="getShopLink + '/singleview/' + getProduct[0].id + '-' + getProduct[0].slug" class="buy-btn-comp">
   
      <span class="regular f-30 w__change">{{$fn.tr('შეძენა')}}</span>
    
  </router-link> -->
      </div>

      <div class="right-col">
          <img :src="_.get(contentData, 'data.list[0].images[0].url')" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import BuyBtn  from "@/components/BuyBtn";
// import OrderService from "@/components/OrderService";
export default {
  props: ['contentData'],
    components: {
        BuyBtn,
        // OrderService
       
    },
    mounted(){
      console.log(this.getProduct[0])
    },
    computed: {
       getShopLink(){
        let _m = this.$store.state.main.indx.menus;
      let dup = [..._m]
      dup = dup.filter(m => m.configs.includes("shop"))
      return dup[0].full_url;
      },


      
     getProduct(){

      //  return _.get(this.contentData, 'data.list[0]');

        let _l = [..._.get(this.contentData, 'data.list')]; 
         for (let i = 0; i < _l.length; i++) {
            let n = []
           let newIngredients = {
             newArr: n,
           }
          
           _l[i].newIngredients = newIngredients;
           
           let attr = _l[i].allAttributes;

           let _attr = this.$store.state.main.indx.attributes.characteristics;
           for (let k = 0; k < _attr.length; k++) {
             for (let j = 0; j < attr.length; j++) {
               if(attr[j] == _attr[k].id){
                n.push(_attr[k])

               }
               
             }
             
           }
         }
         return _l;
     },


     getAlcohol(){
      let list = [...this.getProduct[0].newIngredients.newArr];
   
      list = list.filter(l => l.slug == 'alcohol');

       return list[0];
    },
     getVolume(){
      let list = [...this.getProduct[0].newIngredients.newArr];
    
      list = list.filter(l => l.slug == 'volume');

      
      return list[0];
    },
         getGas(){
      let list = [...this.getProduct[0].newIngredients.newArr];
      
      list = list.filter(l => l.slug == 'gas');

      
      return list[0];
     
    },

     
    },
  
};
</script>

<style lang="scss" scoped>
.buy-btn-comp {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url('../../assets/img/buybtn.png');
  background-size: cover;
  background-repeat: no-repeat;
  width: 173px;
  height: 60px;
  
 
  transition: 0.3s;
  transition-delay: 0.3s;
    span{
        color: white;
    }
 

  transition-delay: 0s;
  transition: all cubic-bezier(0, 0.08, 0.06, 0.99) 0.5s;
  @media (min-width: 1024px) {
    &:hover {
      transform: scale(1.1) rotate(-2deg);
    }
  }
}
</style>

<style lang="scss" scoped>
.jujuna-packs .left-col .desc{
 &::v-deep p, &::v-deep span, &::v-deep h1, &::v-deep h2, &::v-deep h3, &::v-deep h4, &::v-deep h5, &::v-deep h6, &::v-deep strong, &::v-deep i, &::v-deep mark, &::v-deep em,
   &::v-deep small, &::v-deep del, &::v-deep ins, &::v-deep sub, &::v-deep sup{
    
     font-family: "FiraGO-Italic";
     will-change: transform;
   }
}
</style>
